<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.84132 8.60299L1.10944 6.13652C-0.369758 5.4996 -0.369758 3.23919 1.10944 2.60228L6.8471 0.135812C7.2689 -0.0452707 7.73692 -0.0452707 8.15872 0.135812L13.8906 2.60228C15.3698 3.23919 15.3698 5.4996 13.8906 6.13652L8.15872 8.60299C7.72537 8.79031 7.26312 8.78407 6.84132 8.60299ZM7.43274 1.03354C7.47497 1.01242 7.52467 1.01242 7.5669 1.03353L10.2316 2.36571C10.3422 2.42099 10.3422 2.57876 10.2317 2.63405L7.5669 3.96646C7.52467 3.98757 7.47496 3.98757 7.43273 3.96645L4.7683 2.63404C4.65775 2.57876 4.65776 2.42099 4.76831 2.36572L7.43274 1.03354ZM7.5669 4.53353C7.52467 4.51242 7.47497 4.51242 7.43274 4.53354L4.76831 5.86572C4.65776 5.92099 4.65775 6.07876 4.7683 6.13404L7.43273 7.46645C7.47496 7.48757 7.52467 7.48757 7.5669 7.46646L10.2317 6.13405C10.3422 6.07876 10.3422 5.92099 10.2316 5.86571L7.5669 4.53353Z"
    />
    <path
      d="M14.3185 7.79137C14.3358 7.78547 14.3647 7.76776 14.3647 7.76776C14.6061 7.96794 14.7787 8.22229 14.8825 8.5H12.5766L14.3185 7.79137Z"
    />
    <path
      d="M11.8 8.81595L8.58635 10.1234C7.88717 10.4067 7.11287 10.4067 6.41369 10.1234L0.681569 7.79137C0.681569 7.79137 0.652677 7.77366 0.635342 7.76776C-0.346977 8.58838 -0.190961 10.3005 1.10917 10.8259L6.84129 13.1579C7.26311 13.3291 7.72538 13.335 8.15875 13.1579L8.5 13.019V12.1H10.759L11.8 11.6765V8.81595Z"
    />
    <path
      d="M8.5 14.6067C7.82354 14.8776 7.08349 14.8657 6.41262 14.5711L0.681418 12.0448C0.681418 12.0448 0.652531 12.0256 0.635199 12.0192C-0.346962 12.9018 -0.190971 14.763 1.10895 15.3322L6.84015 17.8585C7.2619 18.044 7.72409 18.0504 8.1574 17.8585L10.3318 16.9H8.5V14.6067Z"
    />
    <path d="M13 10H15V13H18V15H15V18H13V15H10V13H13V10Z" />
  </svg>
</template>
